import axios from "axios";
import i18n from "../i18n";

//returns onboarding token for device or null
//pass email and password
async function getToken(email, password, spamProtectionAnswer) 
{
  spamProtectionAnswer.sum = Number(spamProtectionAnswer.sum);

  //set content
  let body = { email: email, password: password, spamProtectionAnswer: spamProtectionAnswer };

  //request
  const token = await axios
    .post(`/Onboarding`, body)
    .then(response => {
        return response;
    })
    .catch((error) => {     
      if(error.message == "Request failed with status code 400")
      {
        error.message = i18n.t("onboarding.permissionFailed");
      }
      return error;
    });

  return token;
}

export default { getToken };
